var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#099095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8307 13.2248C8.8307 13.2248 8.12962 13.9259 7.85801 14.1975C7.3148 14.7407 6.9074 15.9629 7.72221 16.7778C8.53703 17.5926 9.75925 17.1852 10.3025 16.642C10.5741 16.3703 11.6862 15.2582 12.7469 14.1975C13.2902 13.6543 13.3923 12.6701 12.9261 12.2039",
    stroke: "white",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1599 11.7845C15.1599 11.7845 15.8703 11.0741 16.1419 10.8025C16.6851 10.2593 17.0925 9.03706 16.2777 8.22225C15.4629 7.40743 14.2406 7.81484 13.6974 8.35805C13.4258 8.62965 12.3137 9.74183 11.253 10.8025C10.7097 11.3457 10.616 12.3384 11.0822 12.8046",
    stroke: "white",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copylink.ca540066b2fc378eb77586bc03826b73.svg";
export { ForwardRef as ReactComponent };